"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccDatePickerStyle = (0, _react.useMemo)(function () {
    var arrowStyleProps = function arrowStyleProps() {
      return {
        borderColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        borderWidth: "".concat(pxToRem(2), " ").concat(pxToRem(2), " 0 0"),
        width: pxToRem(6),
        height: pxToRem(6),
        top: pxToRem(9)
      };
    };
    var deviceDayTitleProps = function deviceDayTitleProps() {
      var fontSize = isMobileView ? pxToRem(20) : pxToRem(14);
      return {
        fontSize: fontSize
      };
    };
    var deviceDayNameProps = function deviceDayNameProps() {
      var fontSize = isMobileView ? pxToRem(16) : pxToRem(12);
      var margin = isMobileView ? "".concat(pxToRem(12), " ").concat(pxToRem(14), " ").concat(pxToRem(-2)) : "".concat(pxToRem(12), " ").concat(pxToRem(8), " ").concat(pxToRem(-2));
      return {
        fontSize: fontSize,
        margin: margin
      };
    };
    var selectedDayStyle = function selectedDayStyle() {
      return {
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        '&::after': {
          content: '""',
          border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main),
          boxSizing: 'border-box',
          display: 'block',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          borderRadius: '50%'
        }
      };
    };
    var hoverDayStyle = function hoverDayStyle() {
      return {
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
        '&::after': {
          content: '""',
          background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
          boxSizing: 'border-box',
          display: 'block',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          borderRadius: '50%'
        }
      };
    };
    var startDayStyle = function startDayStyle() {
      var _before;
      return {
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        '&::after': {
          content: '""',
          background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
          border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main),
          boxSizing: 'border-box',
          display: 'block',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          borderRadius: '50%'
        },
        '&.react-datepicker__day': {
          '::before': (_before = {}, _defineProperty(_before, direction === 'rtl' ? 'right' : 'left', '50%'), _defineProperty(_before, direction === 'rtl' ? 'left' : 'right', '0'), _before)
        }
      };
    };
    var endDayStyle = function endDayStyle() {
      var _before2;
      return _objectSpread(_objectSpread({}, startDayStyle()), {}, {
        '&.react-datepicker__day': {
          '::before': (_before2 = {}, _defineProperty(_before2, direction === 'rtl' ? 'right' : 'left', '0'), _defineProperty(_before2, direction === 'rtl' ? 'left' : 'right', '50%'), _before2)
        }
      });
    };
    var innerDayStyle = function innerDayStyle() {
      return {
        '&::before': {
          content: '""',
          background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light,
          display: 'block',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -2
        }
      };
    };
    var dayStyleProps = function dayStyleProps(date) {
      var style = _objectSpread({}, deviceDayTitleProps());
      var _ref = props,
        selectedDate = _ref.selectedDate;
      var _ref2 = props,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate;
      if (selectedDate && new Date(selectedDate).toDateString() === date.toDateString()) {
        style = _objectSpread(_objectSpread({}, style), selectedDayStyle());
        return style;
      }
      if (startDate && new Date(startDate).toDateString() === date.toDateString()) {
        style = _objectSpread(_objectSpread({}, style), startDayStyle());
        if (endDate && startDate < endDate) {
          style = _objectSpread(_objectSpread({}, style), innerDayStyle());
        }
        return style;
      }
      if (endDate && new Date(endDate).toDateString() === date.toDateString()) {
        style = _objectSpread(_objectSpread({}, style), endDayStyle());
        if (startDate && startDate < endDate) {
          style = _objectSpread(_objectSpread({}, style), innerDayStyle());
        }
        return style;
      }
      if (startDate && endDate) {
        if (startDate < date && date < endDate) {
          style = _objectSpread(_objectSpread({}, style), innerDayStyle());
        }
      }
      return style;
    };
    var ccDatePicker = (0, _css.css)({
      borderRadius: pxToRem(10),
      overflow: 'hidden',
      textAlign: 'center',
      '.react-datepicker': _objectSpread(_objectSpread({
        fontFamily: fontFamily,
        border: 'none',
        borderRadius: 0,
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
        margin: 0
      }, deviceDayTitleProps()), {}, {
        opacity: props.isDisabled ? 0.6 : 1,
        '.react-datepicker__header': {
          textAlign: 'center',
          backgroundColor: 'transparent',
          borderBottom: 'none',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        '.react-datepicker__current-month': {
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker-time__header': {
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker-year-header': {
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker__year-read-view--down-arrow': _objectSpread({}, arrowStyleProps()),
        '.react-datepicker__month-read-view--down-arrow': _objectSpread({}, arrowStyleProps()),
        '.react-datepicker__month-year-read-view--down-arrow': _objectSpread({}, arrowStyleProps()),
        '.react-datepicker__navigation-icon::before': _objectSpread({}, arrowStyleProps()),
        '.react-datepicker__week': {
          position: 'relative',
          marginBottom: pxToRem(5),
          zIndex: 0
        },
        '.react-datepicker__day-names': _objectSpread(_objectSpread({
          display: 'flex',
          justifyContent: 'space-between'
        }, deviceDayNameProps()), {}, {
          '.react-datepicker__day-name': {
            color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
          }
        }),
        '.react-datepicker__month-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__quarter-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__year-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__day--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__month-text--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__quarter-text--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__year-text--disabled': {
          color: '#ccc'
        }
      })
    });
    var ccDatePickerDay = function ccDatePickerDay(date) {
      var daySize = isMobileView ? 45 : 32;
      return (0, _css.css)({
        '&.react-datepicker__day': _objectSpread({
          position: 'relative',
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
          borderRadius: 0,
          background: 'transparent',
          display: 'inline-flex',
          width: pxToRem(daySize),
          height: pxToRem(daySize),
          lineHeight: pxToRem(daySize),
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'center'
        }, dayStyleProps(date)),
        '&.react-datepicker__day--disabled': {
          opacity: 0.6
        },
        '&.react-datepicker__day:not(.react-datepicker__day--disabled):hover': _objectSpread(_objectSpread({}, selectedDayStyle()), hoverDayStyle())
      });
    };
    var ccDatePickerAnchorBtn = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      direction: 'ltr',
      lineHeight: 1,
      '& > div:nth-child(2)': {
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
      }
    });
    var deviceAnchorBtnProps = function deviceAnchorBtnProps() {
      var width = isMobileView ? '100%' : 'auto';
      return {
        width: width
      };
    };
    var ccRangeDatePickerAnchorBtn = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '& > div': _objectSpread(_objectSpread({
        margin: "0 ".concat(pxToRem(7)),
        textAlign: 'center',
        lineHeight: 1
      }, deviceAnchorBtnProps()), {}, {
        '& > div:nth-child(2)': {
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
        }
      }),
      '& > div:nth-child(2)': {
        width: '1px',
        background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border
      }
    });
    return {
      ccDatePicker: ccDatePicker,
      ccDatePickerDay: ccDatePickerDay,
      ccDatePickerAnchorBtn: ccDatePickerAnchorBtn,
      ccRangeDatePickerAnchorBtn: ccRangeDatePickerAnchorBtn
    };
  }, [basicFontSize, direction, fontFamily, isMobileView, props, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-DatePicker': ccDatePickerStyle.ccDatePicker,
    'cc-DatePicker__day': ccDatePickerStyle.ccDatePickerDay,
    'cc-DatePicker__anchor-btn': ccDatePickerStyle.ccDatePickerAnchorBtn,
    'cc-RangeDatePicker__anchor-btn': ccDatePickerStyle.ccRangeDatePickerAnchorBtn
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;